import {
  useEffect,
  useState
} from "react";

import MainLayout
from "../../components/layout/MainLayout";

import {
  getCurrentStock
}
from "../../api/inventoryApi";

import {
  FaWarehouse,
  FaSearch
} from "react-icons/fa";

const CurrentStock = () => {

  const [stocks,setStocks] =
  useState([]);

  const [search,setSearch] =
  useState("");

  useEffect(()=>{

    loadStocks();

  },[]);

  const loadStocks =
  async()=>{

    try{

      const res =
      await getCurrentStock();

      setStocks(
        res.data.data
      );

    }
    catch(error){

      console.log(error);

    }

  };

  const filteredStocks =
  stocks.filter(
    item =>
      item.material_name
      ?.toLowerCase()
      .includes(
        search.toLowerCase()
      )
  );

  return(

    <MainLayout>

      <div className="card shadow-sm border-0">

        <div className="card-header bg-white d-flex justify-content-between align-items-center">

          <div>

            <h5 className="mb-0">

              <FaWarehouse />

              {" "}
              Current Stock

            </h5>

            <small className="text-muted">

              Live Inventory Status

            </small>

          </div>

        </div>

        <div className="card-body">

          <div
            className="input-group mb-3"
          >

            <span
              className="input-group-text"
            >

              <FaSearch />

            </span>

            <input
              type="text"
              className="form-control"
              placeholder="Search Material"
              value={search}
              onChange={(e)=>
                setSearch(
                  e.target.value
                )
              }
            />

          </div>

          <table className="table table-hover">

            <thead>

              <tr>

                <th>Code</th>
                <th>Material</th>
                <th>Unit</th>
                <th>Current Stock</th>

              </tr>

            </thead>

            <tbody>

              {
                filteredStocks.map(
                  (item)=>(
                    <tr
                      key={item.id}
                    >

                      <td>
                        {item.material_code}
                      </td>

                      <td>
                        {item.material_name}
                      </td>

                      <td>
                        {item.unit}
                      </td>

                      <td>

                        <span
                          className={
                            Number(
                              item.current_stock
                            ) > 0
                            ?
                            "badge bg-success"
                            :
                            "badge bg-danger"
                          }
                        >

                          {
                            item.current_stock
                          }

                        </span>

                      </td>

                    </tr>
                  )
                )
              }

            </tbody>

          </table>

        </div>

      </div>

    </MainLayout>

  );

};

export default CurrentStock;